import api from "../../../shared/services/api";

export async function listContas() {
  const response = await api.get("/instagram/contas");
  return response.data?.data || [];
}

// Importante: deixar o erro do axios propagar com a resposta intacta,
// para a UI poder ler body.error (MULTIPLE_PAGES.pages, retry_after_sec, etc).
export async function conectarConta({ system_user_token, page_id }) {
  const payload = { system_user_token };
  if (page_id) payload.page_id = page_id;
  const response = await api.post("/instagram/contas", payload);
  return response.data?.conta;
}

export async function desconectarConta(id) {
  const response = await api.delete(`/instagram/contas/${id}`);
  return response.data;
}

// ─────────────────────────────────────────────────────────────────────────
// INBOX — Instagram Direct
// O backend pode embrulhar a resposta em { data: ... } ou devolver direto;
// todos os helpers normalizam pra um shape estável pra UI.
// ─────────────────────────────────────────────────────────────────────────

/**
 * Lista conversas de uma conta (mais recentes primeiro).
 * @param {number} contaId
 * @param {{ limit?: number, cursor?: string|null, busca?: string, filtro?: string }} params
 * @returns {Promise<{ conversas: Array, cursor: string|null, hasMore: boolean }>}
 */
export async function listConversas(contaId, params = {}) {
  const query = {};
  if (params.limit)  query.limit  = params.limit;
  if (params.cursor) query.cursor = params.cursor;
  if (params.busca && params.busca.trim())  query.busca  = params.busca.trim();
  if (params.filtro && params.filtro !== "todas") query.filtro = params.filtro;

  const resp = await api.get(`/instagram/contas/${contaId}/conversas`, { params: query });
  const payload = resp.data?.data ?? resp.data ?? {};
  // Aceita lista crua ([...]) ou objeto paginado ({ conversas, cursor, hasMore }).
  const conversas = Array.isArray(payload)
    ? payload
    : (payload.conversas ?? payload.data ?? []);
  return {
    conversas,
    cursor:  Array.isArray(payload) ? null : (payload.cursor ?? null),
    hasMore: Array.isArray(payload) ? false : (payload.hasMore ?? false),
  };
}

/**
 * Busca uma conversa específica.
 * @param {number} contaId
 * @param {number} cid
 */
export async function getConversa(contaId, cid) {
  const resp = await api.get(`/instagram/contas/${contaId}/conversas/${cid}`);
  return resp.data?.data ?? resp.data ?? null;
}

/**
 * Lista mensagens de uma conversa (keyset desc — mais recentes primeiro).
 * @param {number} contaId
 * @param {number} cid
 * @param {{ limit?: number, cursor?: string|null }} params
 * @returns {Promise<{ mensagens: Array, cursor: string|null, hasMore: boolean }>}
 */
export async function listMensagens(contaId, cid, params = {}) {
  const query = {};
  if (params.limit)  query.limit  = params.limit;
  if (params.cursor) query.cursor = params.cursor;

  const resp = await api.get(
    `/instagram/contas/${contaId}/conversas/${cid}/mensagens`,
    { params: query },
  );
  const payload = resp.data?.data ?? resp.data ?? {};
  const mensagens = Array.isArray(payload)
    ? payload
    : (payload.mensagens ?? payload.data ?? []);
  return {
    mensagens,
    cursor:  Array.isArray(payload) ? null : (payload.cursor ?? null),
    hasMore: Array.isArray(payload) ? false : (payload.hasMore ?? false),
  };
}

/**
 * Envia uma DM de texto (Instagram Direct só suporta texto no envio).
 * @param {number} contaId
 * @param {number} cid
 * @param {string} text
 */
export async function enviarMensagem(contaId, cid, text) {
  const resp = await api.post(
    `/instagram/contas/${contaId}/conversas/${cid}/mensagens`,
    { text },
  );
  return resp.data?.data ?? resp.data;
}

/**
 * Marca a conversa como lida.
 * @param {number} contaId
 * @param {number} cid
 */
export async function marcarLido(contaId, cid) {
  const resp = await api.post(
    `/instagram/contas/${contaId}/conversas/${cid}/marcar-lido`,
  );
  return resp.data;
}
